import { Declaration } from '@e-origin/shared';

import { isHighValueDeclaration } from '@utils';
import { DeclarationHVStatusIndicator } from './DeclarationHVStatusIndicator';
import { DeclarationLVStatusIndicator } from './DeclarationLVStatusIndicator';

interface DeclarationStatusIndicatorProps {
  declaration: Declaration;
}

export const DeclarationStatusIndicator: React.FC<DeclarationStatusIndicatorProps> = ({ declaration }) => {
  return isHighValueDeclaration(declaration.generalInfo.group) ? (
    <DeclarationHVStatusIndicator declaration={declaration} />
  ) : (
    <DeclarationLVStatusIndicator declaration={declaration} />
  );
};
